import http from "../http-common";
import { IEduLearnerResponseData, IEduLearnerPaginatedResponse } from "../types/EduLearner";

const getAll = (filterCriteria: string = '') => {
  return http.get<IEduLearnerPaginatedResponse>(`/edu-learners${filterCriteria}`);
};

const get = (eduLearnerId: string) => {
  return http.get<IEduLearnerResponseData>(`/edu-learners/${eduLearnerId}`);
};

const getCrmStatuses = () => {
  return http.get<any[]>(`/edu-learners/crm-statuses`);
};

const getGroups = () => {
  return http.get<any[]>(`/edu-learners/groups`);
};

const getCourses = () => {
  return http.get<any[]>(`/edu-learners/courses`);
};

const updateCrmStatus = (eduLearnerId: string, data: any) => {
  return http.patch<any>(`/edu-learners/${eduLearnerId}/crm-status`, data);
};

const getNotes = (eduLearnerId: string) => {
  return http.get<any[]>(`/edu-learners/${eduLearnerId}/notes`);
};

const createNote = (eduLearnerId: string, data: any) => {
  return http.post<any>(`/edu-learners/${eduLearnerId}/notes`, data);
};

const removeNote = (noteId: number) => {
  return http.delete<any>(`/edu-learner-notes/${noteId}`);
};

const EduLearnerService = {
  getAll,
  get,
  getCrmStatuses,
  getGroups,
  getCourses,
  updateCrmStatus,
  getNotes,
  createNote,
  removeNote,
};

export default EduLearnerService;
